import {css, useTheme} from '@mui/material';
import {
  DlMuiDynamicIcon,
  DlMuiTypography,
  GetStylesFunction,
  mixins,
} from '@wallaby-ui/core';
import * as React from 'react';
import {TemplatedCellRendererParams} from 'src/js/containers/grid/grid_types';
import {
  TimelineEventTypeEnum,
  TimelineEventTypeMap,
} from 'src/js/containers/hospitalizations';

import {TranslateEnumFormatter} from './TranslateEnumFormatter';

type Props = TemplatedCellRendererParams<any>;

export const HospitalizationDetailTimelineEventTypeFormatter: React.FC<
  Props
> = (props) => {
  const {value} = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  // TODO-JK: change to correct enum when available and specify icon title
  const iconName =
    TimelineEventTypeMap[value] === undefined
      ? 'riskFactorStarIcon'
      : TimelineEventTypeMap[value];

  return (
    <div css={styles.wrapper}>
      <DlMuiDynamicIcon
        iconName={iconName}
        inputCss={styles.icon}
        svgIconInputCss={styles.icon}
        iconTitle={''}
        noButtonStyles
      />
      <div css={styles.textWrapper}>
        <TranslateEnumFormatter
          value={value}
          colDef={{cellRendererParams: {enumName: 'MerieEventTypeEnum'}}}
        />
      </div>
    </div>
  );
};

HospitalizationDetailTimelineEventTypeFormatter.displayName =
  'HospitalizationDetailTimelineEventTypeFormatter';

const getStyles: GetStylesFunction = (options) => ({
  icon: css({
    height: '16px',
    width: '16px',
    flexShrink: 0,
    color: `${options?.theme?.palette.custom.coolGray['900']}`,
  }),
  wrapper: css`
    display: flex;
    gap: ${options?.theme?.spacing(1)};
    align-items: center;
  `,
  textWrapper: css`
    overflow: hidden;
    min-width: 0;
    ${mixins.dlTextOverflowEllipses};
  `,
});
